import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'
import IconTag from './IconTag'

const CardTitle = ({ iconName, title }) => {
  return (
    <div>
      <Grid container sapcing={1} className={'u-ml-small u-mr-small u-mt-xsmall u-mb-small'}>
        <Grid item sm={2}>
          <div className="c-icon c-icon--large">
            <IconTag name={iconName} />
          </div>
        </Grid>
        <Grid item sm={8} className={iconName && 'u-text-right text-right'}>
          <Typography variant={'h5'} className="u-mb-xsmall u-mt-xsmall u-pl-small u-ml-small">
            {title}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}

CardTitle.propTypes = {
  iconName: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default CardTitle
